import $ from './app/jquery-shim.js';
import Utils from './app/utils.js';
import Accordion from './app/accordion.js';
import Anchor from './app/anchor.js';
import FixedHeader from './app/fixedheader.js';
import HeightLine from './app/heightline.js';
import ResponsiveTable from './app/responsive-table.js';
import Slidebar from './app/slidebar.js';
import Tab from './app/tab.js';
import CurrentNav from './app/current-nav.js';
import buildFormat from './app/format.js';
import OwlCarousel from 'owl.carousel';
//import ScrollReveal from "scrollreveal";

import fontAwesome from "font-awesome/scss/font-awesome.scss"
import OwlCss from "owl.carousel/dist/assets/owl.carousel.css"
import OwlThemeCss from "owl.carousel/dist/assets/owl.theme.default.css"

import SlickCarousel from 'slick-carousel';
import SlickCarouselCss from "slick-carousel/slick/slick-theme.scss";
import SlickCarouselCsss from "slick-carousel/slick/slick.scss";

class App {
  constructor() {
    this.Utils = new Utils();
    this.Accordion = new Accordion();
    this.Anchor = new Anchor();
    this.FixedHeader = new FixedHeader();
    this.HeightLine = new HeightLine();
    this.ResponsiveTable = new ResponsiveTable();
    this.Slidebar = new Slidebar();
    this.CurrentNav = new CurrentNav();
    this.Tab = new Tab();

    //SPメニューの高さ取得
    function menuHight() {
      var win = $(window).innerWidth();
      if (win > 750) {
        return false;
      }

      var $smpHeaderHeight = $('.l-header').height();
      var windowHeight = window.innerHeight;
      var winH = windowHeight - $smpHeaderHeight;

      console.log($smpHeaderHeight);

      //動かすターゲットを取得
      var targetSlidebarWrap = $('.c-slidebar-menu'),
        targetSlidebarMenu = $('.c-slidebar__parent'),
        targetSlidebarBtn = $('.c-slidebar-menu__parent');


      //いざ実行(クリックしたら処理を実行する)
      targetSlidebarBtn.on('click', function () {
        $('.c-slidebar-menu').toggleClass('is-active');

      });
    }

    //フッターメニューSPスライド
    function menuSlide() {
      var win = $(window).innerWidth();
      if (win > 750) {
        return false;
      }
      $('.l-footer__block').on('click', function () {
        $(this).children(".l-footer__menutitle").toggleClass('is-open');
        $(this).children(".l-footer__menulist.is-sub").slideToggle();
      })
    }

    /**
     * ループスライダー
     */
    function loopSlider() {
      var targetInner = $('.c-loop-slider__wrap'),
        targetInnerUl = $('.c-loop-slider__wrap > ul'),
        targetInnerItems = targetInnerUl.children(),
        slideEasing = 'linear',
        slideSpeed = 4000;
      for (var i = 0; i < 2; i++) {
        targetInnerItems.clone().prependTo(targetInnerUl);
        targetInnerItems.clone().appendTo(targetInnerUl);
      }
      targetInnerUl.each(function () {
        var self = $(this);
        //liの個数を取得
        var selfChildItemLength = self.find('li').length;
        //liの幅を取得
        var selfChildList = self.find('li').innerWidth();
        //ulを複製する
        // self.clone().appendTo( targetInner );
        //ulの親divに幅を付与する
        // targetInner.width( ( selfChildList * selfChildItemLength ) * 2 )
        targetInner.width(selfChildList * selfChildItemLength);

        // 親divをアニメーションさせる
        function galleryAnimate() {
          targetInner.animate(
            {
              left: '-' + ((selfChildList * selfChildItemLength) / 3 * 2) + 'px'
            }, {
              duration: slideSpeed * selfChildItemLength,
              easing: slideEasing,
              complete: function () {
                targetInner.css({
                  left: 0
                });
                galleryAnimate()
              }
            }
          );
        }

        galleryAnimate()
      });
    }


    //owlcarousel
    function owlCarousel() {
      var owls = $('.owl-carousel');
      if (owls.length === 0) {
        return false
      }
      //->スライダー
      owls.imagesLoaded(function () {
        $('.c-main-visual__slider').owlCarousel({
          items: 1,
          margin: 0,
          dots: true,
          loop: true,
          nav: false,
          autoplayHoverPause: false,
          autoplay: true,
          autoplaySpeed: 500,
          autoplayTimeout: 5000,
          autoWidth: false,
          autoHeight: false,
          animateOut: 'fadeOut',
          center: true,
        });
      });
      owls.imagesLoaded(function () {
        $('.c-top-banner__slider').owlCarousel({
          items: 1,
          margin: 0,
          dots: false,
          loop: true,
          nav: true,
          autoplayHoverPause: false,
          autoplay: true,
          autoplaySpeed: 500,
          autoplayTimeout: 5000,
          autoWidth: false,
          autoHeight: false,
          center: true,
          navText: ['<img src="/wp-content/themes/sunset-shinjuku-html/dist/assets/images/icon-slider-prev.svg" />', '<img src="/wp-content/themes/sunset-shinjuku-html/dist/assets/images/icon-slider-next.svg" />'],
        });
      });
      //->カード_カルーセル
      owls.imagesLoaded(function () {
        $('.js-card-slider').owlCarousel({
          margin: 0,
          dots: false,
          loop: true,
          nav: true,
          autoplayHoverPause: true,
          autoplay: true,
          autoplaySpeed: 500,
          autoWidth: false,
          autoHeight: false,
          center: true,
          navText: ['<img src="../assets/images/icon-slider-prev.svg" />', '<img src="../assets/images/icon-slider-next.svg" />'],
          responsive: {
            // breakpoint from 0 up
            0: {
              items: 1,
            },
            // breakpoint from 750 up
            750: {
              items: 3,
            }
          }
        });
      });
    }

    function slick() {
      var $image;
      // カウント表示
      $(function () {
        $('#slick').on('init', function (event, slick) {
          $image = $($('.slick-current').find('.c-slider__image')[0]);
          $('.c-slider__main-wrap').append('<div class="c-slider__detail"><div class="slick-counter"><span class="current"></span> / <span class="total"></span></div><div class="c-slider__caption"></div></div>');
          $('.current').text(slick.currentSlide + 1);
          $('.total').text(slick.slideCount);
          $('.c-slider__caption').text($image.data('caption'));
        })
          .slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            useCSS: true,
            // fade: true,
            asNavFor: '.js-slider-nav'
          })
          .on('beforeChange', function (event, slick, currentSlide, nextSlide) {
            $('.current').text(nextSlide + 1);
          })
          .on('afterChange', function (event, slick, currentSlide, nextSlide) {
            $image = $($('.slick-current').find('.c-slider__image')[0]);
            $('.c-slider__caption').text($image.data('caption'));
          });
      });

      $('.js-slider-nav').slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        asNavFor: '.js-slider-for',
        dots: true,
        centerMode: false,
        focusOnSelect: true
      });
    }

    function mainvisualAnim() {
      var $mainvisual = $('.c-main-visual');
      if ($mainvisual.length == 0) {
        return false;
      }
      $mainvisual.addClass('is-animating');
    }

    $(window).on('load', function () {
      mainvisualAnim();
    });

    $(function () {
      menuSlide();
      owlCarousel();
      slick();
      loopSlider();
    });
  }
}

window.GApp = new App();
